import React, { useState, useEffect, forwardRef } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';

import './colorSelector.scss';

const { Option: SelectOption } = Select;

export const colorsMapping = {
  yellow: '#C28A00',
  green: '#27897E',
  purple: '#4B20AB',
  red: '#B5485B',
  blue: '#415385',
};
const colors = Object.values(colorsMapping);

function getKeyByValue(value) {
  return Object.keys(colorsMapping).find((key) => colorsMapping[key] === value);
}
// 以前的对应关系，先保留
// {
//   'yellow': '#FFB600',
//   'green': '#64DCBF',
//   'purple': '#B57ACE',
//   'red': '#F77389',
//   'blue': '#5273E0',
// }

const ColorBlock = ({ color }) => (
  <div className="color-block" style={{ backgroundColor: color }} />
);

const ColorSelector = forwardRef(
  ({ value, onChange = () => {}, formChange = () => {}, ...props }, ref) => {
    // const colors = useSelector((state) => state.common.config.colors);
    const [color, setColor] = useState(null);

    const onColorChange = (newColor) => {
      setColor(newColor);
      onChange(newColor);
      formChange();
    };

    if (value !== color && typeof value !== 'undefined') {
      setColor(value);
    }

    useEffect(() => {
      onChange(value);
    }, [value]);

    return (
      <div className="color-selector">
        <Select
          value={color}
          maxListHeight={270}
          onSelect={onColorChange}
          size="large"
          dropdownClassName="color-selector-dropdown"
        >
          {colors.map((e, i) => (
            <SelectOption value={getKeyByValue(e)} key={i}>
              <ColorBlock color={e} />
            </SelectOption>
          ))}
        </Select>
      </div>
    );
  },
);

export default ColorSelector;
